import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { ThemeProvider, createTheme } from '@mui/material/styles'

import ProtectedRoutes from './components/common/routes/ProtectedRoutes'
import GoogleAnalytics from './utils/analytics/GoogleAnalytics'

import { VibioThemeProvider } from './context/VibioThemeProvider'
import SecurityContextProvider from './context/SecurityContextProvider'

import LandingPage from './pages/landing/LandingPage'
import LoginPage from './pages/signup-login/LoginPage'
import StudioPage from './pages/studio/StudioPage'
import TermsOfService from './pages/terms-privacy/TermsOfService'
import PrivacyPolicy from './pages/terms-privacy/PrivacyPolicy'
import OnboardingPage from './pages/onboarding/OnboardingPage'
import PaymentFailPage from './pages/payment/PaymentFailPage'
import PageNotFound from './pages/notfound/PageNotFound'

import './App.css'
import VideoPage from './pages/vibiopage/VibioPage'
import PublicReportPage from './pages/report/PublicReportPage'

const queryClient = new QueryClient()

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF1493',
      second: '#e9ecef',
      third: '#f2f2f2',
      bg: '#fcfcfc',
      bg2: '#f4f4f4',
      black: "#000",
    },
    links: {
      main: '#2B061E',
      icon: "#2B061E",
      btn: "#FF1493",
      text: "#fdfdfd",
      bg: "#03045e",
    },
    text: {
      regular: "#f6f6f6",
      second: '#211A1E',
      gray: '#364153',
      darkGray: '#343a40',
    }
  },
})

function App() {
  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <SecurityContextProvider>
          <VibioThemeProvider>
            <BrowserRouter>
              <GoogleAnalytics />

              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<LoginPage />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/r/:token" element={<PublicReportPage />} />
                <Route path="/:username" element={<VideoPage />} />

                <Route element={<ProtectedRoutes />}>
                  <Route path="/studio" element={<StudioPage />} />
                  <Route path="/onboarding" element={<OnboardingPage />} />
                  {/* Legacy entry points now funnel into the unified onboarding flow. */}
                  <Route path="/welcome" element={<Navigate to="/onboarding" replace />} />
                  <Route path="/signup/choose-plan" element={<Navigate to="/onboarding" replace />} />
                  <Route path="/payment-fail" element={<PaymentFailPage />} />
                </Route>
              </Routes>

            </BrowserRouter>
          </VibioThemeProvider>
        </SecurityContextProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

export default App
